import styled from "styled-components";
import Button from "../common/Button";

const ConveyorWriteActionButtonsBlock = styled.div`
    // margin-top: 1rem;
    // margin-bottom: 3rem;
    margin: 1rem 1rem 3rem;
`;

// TagBox에서 사용하는 버튼과 일치하는 높이로 설정한 후 서로 간의 여백 지정
const StyledButton = styled(Button)`
    height: 2.125rem;
    & + & {
        margin-left: 0.5rem;
    }
`;

const ConveyorWriteActionButtons = ({ onPublish, onCancel, isEdit, language }) => {

    const isEN = language === 'EN' ? true : false;
    const isJP = language === 'JP' ? true : false;


    return (
        <ConveyorWriteActionButtonsBlock>
            <StyledButton cyan onClick={onPublish}>{isEN ? "Conveyor" : isJP ? "コンベヤー" : "컨베이어"} {isEdit ? (isEN ? "Edit" : isJP ? "修正" : "수정") : (isEN ? "Write" : isJP ? "書く" : "쓰기")}</StyledButton>
            <StyledButton onClick={onCancel}>{isEN ? "Cancel" : isJP ? "キャンセル" : "취소"}</StyledButton>
        </ConveyorWriteActionButtonsBlock>
    );
};

export default ConveyorWriteActionButtons;